<template>
  <vSelect
    ref="select"
    id="test"
    class="select__select select__select--select"
    :class="{'select__select--dropdown-append-to-top': dropdownAppendToTop}"
    :placeholder="placeholder"
    :label="label"
    :options="selectData"
    :value="value"
    @search="handleSearch"
    @input="handleInput"
    @search:focus="handleFocus"
    @search:blur="handleBlur"
    :clearable="clearable"
    :disabled="disabled"
    :searchable="searchable"
    :filterable="filterable"
  >
    <span slot="no-options">{{ emptyError }}</span>

    <template v-slot:search="slotProps">
      <slot name="search" v-bind="slotProps"></slot>
    </template>

    <template v-slot:option="slotProps">
      <slot name="option" v-bind="slotProps"></slot>
    </template>
  </vSelect>
</template>

<script>
import { debounce } from '../../mixins'
import vSelect from 'vue-select'

export default {
  name: 'SelectInput',
  mixins: [debounce],
  components: {
    vSelect
  },
  data () {
    return {
      dropdownAppendToTop: false
    }
  },
  props: {
    label: String,
    value: [String, Number, Object],
    selectData: [Object, Array],
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String,
    emptyError: String,
    calculateDropdownPosition: Boolean,
    searchable: {
      type: Boolean,
      default: true
    },
    filterable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleSearch (value) {
      this.$emit('search', value)
    },
    handleInput (value) {
      this.$emit('input', value)
    },
    handleFocus (value) {
      this.$emit('focus', value)
    },
    handleBlur (value) {
      this.$emit('blur', value)
    },
    calculatePosition () {
      const dropdown = this.$refs.select.$refs.dropdownMenu
      const selectPositionBottom = this.$refs.select.$el.getBoundingClientRect().bottom
      const windowHeigth = window.innerHeight

      this.dropdownAppendToTop = dropdown && windowHeigth - selectPositionBottom < dropdown.clientHeight
    }
  },
  watch: {
    selectData () {
      if (this.calculateDropdownPosition) setTimeout(this.calculatePosition, 0)
    }
  },
  mounted () {
    if (this.calculateDropdownPosition) {
      window.addEventListener('scroll', () => {
        this.debounce(this.calculatePosition, 20)
      })
    }
  },
  destroyed () {
    if (this.calculateDropdownPosition) {
      window.removeEventListener('scroll', () => {
        this.debounce(this.calculatePosition, 20)
      })
    }
  }
}
</script>

<style lang="sass">

@import '~@/styles/blocks/checkout-form/libraries-elements'

.select__select
  position: relative
  width: 100%
  color: $text-color
  background-color: #fff

  .vs__search
    padding: 5px 14px
    font-size: 16px

    &::placeholder
      color: $placeholder-color

  .vs__dropdown-menu
    box-shadow: 0 2px 10px rgba(51, 51, 51, 0.25)
    border: 0
    max-height: 200px

    li
      font-size: 16px!important

  .vs__dropdown-option
    padding: 9px 16px
    font-size: 16px

    &--highlight
      background: $nd-disabled-background-color
      color: $text-color

  .vs__selected
    display: block
    width: 90%
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap
    margin: 7px 9px 0
    font-size: 16px

  .vs__dropdown-toggle
    height: 40px

.select__select--dropdown-append-to-top
  .vs__dropdown-menu
    box-shadow: 2px 0 10px rgba(51, 51, 51, 0.25)
    border: 0
    max-height: 200px
    bottom: 100%
    top: auto

.select__select:not(.select__select--select)
  .vs__actions
    display: none

</style>
